export default {
    animation: {
        type: [Boolean, Object],
        default: undefined
    }, 
    collapsible: {
        type: Boolean,
        default: undefined
    }, 
    contentUrls: {
        type: Array,
        default: undefined
    }, 
    dataContentField: {
        type: String,
        default: undefined
    }, 
    dataContentUrlField: {
        type: String,
        default: undefined
    }, 
    dataImageUrlField: {
        type: String,
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    dataSpriteCssClass: {
        type: String,
        default: undefined
    }, 
    dataTextField: {
        type: String,
        default: undefined
    }, 
    dataUrlField: {
        type: String,
        default: undefined
    }, 
    navigatable: {
        type: Boolean,
        default: undefined
    }, 
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    tabPosition: {
        type: String,
        default: undefined
    }, 
    value: {
        type: String,
        default: undefined
    }, 

    // Events
    activate: Function, 
    contentLoad: {
        type: Function,
        default: undefined
    },  
    error: Function, 
    select: Function, 
    show: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoTabStrip/TabStripProps.js